import React, { useState } from "react";
import styles from "./AccordionCategory.module.css";
import { isNodeSelected } from "./accordionTree.helpers";

const AccordionItem = ({ node, tree, onToggle, level = 0, disabled }) => {
  const [open, setOpen] = useState(false);
  const checked = isNodeSelected(tree, node.id);
  const hasChildren = node.children?.length > 0;

  return (
    <div style={{ paddingLeft: level * 18 }}>
      <div className={styles.row}>
        {hasChildren && (
          <span className={styles.arrow} onClick={() => setOpen(!open)}>
            {open ? "▼" : "▶"}
          </span>
        )}

        {
          <input
            type="checkbox"
            checked={checked}
            onChange={() => onToggle(node)}
            disabled={disabled}
          />
        }
        <span>{node.name}</span>
      </div>

      {open &&
        hasChildren &&
        node.children.map((child) => (
          <AccordionItem
            key={child.id}
            node={child}
            tree={tree}
            onToggle={onToggle}
            level={level + 1}
            disabled={disabled}
          />
        ))}
    </div>
  );
};

export default AccordionItem;
